const fr = {
  meta: {
    home: {
      title: "Manifestify | App de Manifestation et d'Affirmations",
      description:
        "Manifestify est une application de manifestation et d'affirmations quotidiennes pour iOS et Android. Créez votre manifeste personnel, posez vos intentions, composez des tableaux de visualisation et décodez vos rêves avec l'IA.",
    },
    blog: {
      title: 'Blog Manifestation : Affirmations, Guides et Méthodes',
      description:
        "Des guides experts pour manifester : affirmations quotidiennes, méthode 369, tableaux de visualisation, scripting et interprétation des rêves. Nouveaux articles de l'équipe Manifestify.",
    },
    notFound: {
      title: 'Page introuvable | Manifestify',
      description: "La page que vous cherchez n'existe pas.",
    },
    terms: {
      title: 'Conditions Générales | Manifestify',
      description: "Les conditions générales d'utilisation de l'application et du site Manifestify.",
    },
    privacy: {
      title: 'Politique de Confidentialité | Manifestify',
      description: 'Comment Manifestify collecte, utilise et protège vos données personnelles.',
    },
  },

  nav: {
    brandAria: "Accueil Manifestify",
    mainAria: 'Navigation principale',
    blog: 'Blog',
    getApp: "Télécharger l'app",
    languageAria: 'Changer de langue',
    languageLabel: 'Langue',
  },

  store: {
    downloadOn: 'Télécharger dans',
    appStore: "l'App Store",
    getItOn: 'DISPONIBLE SUR',
    googlePlay: 'Google Play',
    appleAria: "Télécharger Manifestify dans l'App Store",
    googleAria: 'Obtenir Manifestify sur Google Play',
  },

  home: {
    hero: {
      titleLine1: 'Manifestez vos rêves, chaque jour.',
      titleAccent: 'Avec Manifestify !',
      subtitle:
        "L'application de manifestation qui fait vivre votre pratique : affirmations quotidiennes, manifeste personnel, tableaux de visualisation, intentions et interprétation des rêves par IA, le tout au même endroit. Répétez. Croyez. Devenez.",
      note: 'Téléchargement gratuit · iOS et Android',
    },
    features: {
      titlePre: 'Tout ce dont vous avez besoin pour ',
      titleAccent: 'manifester',
      titlePost: '',
      subtitle:
        "Une seule app pour toute votre pratique, de votre première affirmation du matin au décodage du rêve de la nuit dernière.",
      items: [
        {
          title: 'Affirmations quotidiennes',
          text: "Des centaines d'affirmations soigneusement rédigées sur l'amour, l'argent, la santé, la confiance et la paix intérieure, livrées chaque jour.",
        },
        {
          title: 'Manifeste personnel',
          text: 'Transformez vos objectifs en un manifeste personnel que vous lisez et renforcez chaque jour, pour garder vos rêves sous les yeux.',
        },
        {
          title: "Pose d'intentions",
          text: "Définissez des intentions quotidiennes claires et laissez l'app vous garder ancré à ce qui compte vraiment pour vous.",
        },
        {
          title: 'Tableau de visualisation',
          text: 'Composez un tableau de visualisation numérique de la vie que vous créez et visualisez-le partout, à tout moment.',
        },
        {
          title: 'Interprétation des rêves par IA',
          text: "Décrivez votre rêve et découvrez ses messages cachés grâce à des analyses fines propulsées par l'IA.",
        },
        {
          title: "Cartes d'énergie",
          text: "Tirez une carte d'énergie chaque jour : un moment de recul et une dose d'inspiration fraîche.",
        },
        {
          title: 'Rappels quotidiens',
          text: 'Des notifications douces aux heures que vous choisissez, pour que votre pratique ne dépende ni de la mémoire ni de la motivation.',
        },
        {
          title: 'Thèmes et fonds d’écran',
          text: "De beaux thèmes et fonds d'écran qui rendent votre pratique personnelle et inspirante.",
        },
      ],
    },
    how: {
      titlePre: 'Comment ça ',
      titleAccent: 'marche',
      titlePost: '',
      steps: [
        {
          title: 'Posez votre intention',
          text: "Choisissez ce que vous voulez manifester et composez votre manifeste personnel à partir de centaines d'affirmations sélectionnées.",
        },
        {
          title: 'Pratiquez chaque jour',
          text: "Répétez vos affirmations, visualisez votre tableau et tirez votre carte d'énergie. Les rappels entretiennent votre série.",
        },
        {
          title: 'Croyez et devenez',
          text: 'Voyez votre concentration, votre confiance et vos choix évoluer à mesure que votre pratique se cumule jour après jour.',
        },
      ],
    },
    blogTeaser: {
      titlePre: "Apprenez l'art de la ",
      titleAccent: 'manifestation',
      titlePost: '',
      subtitle:
        "Des guides et des techniques de l'équipe Manifestify, écrits pour une vraie pratique quotidienne.",
      viewAll: 'Voir tous les articles →',
    },
    faq: {
      titlePre: 'Questions ',
      titleAccent: 'fréquentes',
      titlePost: '',
      items: [
        {
          q: "Qu'est-ce que Manifestify ?",
          a: "Manifestify est une application de manifestation et d'affirmations quotidiennes pour iOS et Android. Elle réunit toute votre pratique : des affirmations par catégories comme l'amour, la carrière, l'abondance et la confiance, un manifeste personnel, la pose d'intentions, un tableau de visualisation, des rappels quotidiens, des cartes d'énergie et l'interprétation des rêves par IA.",
        },
        {
          q: 'Manifestify est-elle gratuite ?',
          a: "Oui. Manifestify se télécharge et s'utilise gratuitement sur l'App Store comme sur Google Play. Les offres premium facultatives débloquent la bibliothèque complète d'affirmations et des fonctions avancées comme l'interprétation des rêves par IA en illimité.",
        },
        {
          q: "Qu'est-ce que la manifestation ?",
          a: "La manifestation est la pratique qui consiste à faire advenir vos objectifs par une attention focalisée, une croyance positive et une action régulière. Ses techniques incluent les affirmations quotidiennes, la visualisation, les tableaux de visualisation, le scripting et la méthode 369.",
        },
        {
          q: 'Comment fonctionnent les affirmations quotidiennes ?',
          a: "Les affirmations sont de courtes phrases positives, au présent, que vous répétez chaque jour. Au fil des semaines, elles remodèlent votre dialogue intérieur et orientent votre attention vers les opportunités alignées avec vos objectifs. La régularité est la clé : c'est pourquoi Manifestify propose des rappels quotidiens.",
        },
        {
          q: 'Manifestify est-elle disponible sur iPhone et Android ?',
          a: "Oui. Manifestify est disponible pour iPhone et iPad sur l'App Store, et pour les appareils Android sur Google Play.",
        },
        {
          q: "Comment fonctionne l'interprétation des rêves par IA ?",
          a: "Vous décrivez votre rêve dans l'app, et Manifestify analyse ses symboles, ses émotions et ses thèmes pour vous livrer une interprétation instantanée et nuancée, que vous pouvez affiner avec votre propre contexte.",
        },
      ],
    },
    download: {
      title: 'Commencez à manifester dès aujourd’hui',
      text: "Rejoignez celles et ceux qui commencent chaque matin avec intention. Téléchargez Manifestify gratuitement et installez une pratique qui dure.",
    },
  },

  blog: {
    titlePre: 'Le ',
    titleAccent: 'Blog',
    titlePost: ' Manifestify',
    subtitle:
      "Des guides pratiques sur la manifestation, les affirmations, la visualisation et l'interprétation des rêves. Tout pour bâtir une pratique quotidienne qui fonctionne.",
    schemaName: 'Le Blog Manifestify',
    schemaDescription:
      "Guides sur la manifestation, les affirmations quotidiennes, les tableaux de visualisation, le scripting et l'interprétation des rêves.",
    readTime: '{n} min de lecture',
  },

  post: {
    breadcrumbAria: "Fil d'Ariane",
    home: 'Accueil',
    blog: 'Blog',
    ctaTitle: 'Passez à la pratique avec Manifestify',
    ctaText:
      "Affirmations quotidiennes, manifeste personnel, tableaux de visualisation, intentions et interprétation des rêves par IA. Toute votre pratique de manifestation dans une app gratuite.",
    faqTitle: 'Questions fréquentes',
    relatedTitle: 'Continuez votre lecture',
    relatedAria: 'Articles liés',
  },

  notFound: {
    text: "Cette page n'existe pas, mais vos rêves, si.",
    backHome: "Retour à l'accueil",
    readBlog: 'Lire le blog',
  },

  footer: {
    tagline:
      "Manifestez vos rêves, chaque jour. Affirmations, intentions, tableaux de visualisation et interprétation des rêves dans une seule app.",
    exploreTitle: 'Explorer',
    exploreAria: 'Explorer',
    home: 'Accueil',
    blog: 'Blog',
    downloadTitle: "Télécharger l'app",
    downloadAria: 'Téléchargement',
    appStoreLink: 'iPhone et iPad (App Store)',
    playStoreLink: 'Android (Google Play)',
    legalTitle: 'Mentions légales',
    legalAria: 'Mentions légales',
    terms: 'Conditions Générales',
    privacy: 'Politique de Confidentialité',
    copyright: '© {year} Manifestify par Portal Studio. Tous droits réservés.',
  },

  legal: {
    back: 'Retour',
    translationNotice:
      "Cette traduction est fournie à titre indicatif. Seule la version anglaise de ce document fait foi.",
    lastUpdated: 'Dernière mise à jour : {date}',
  },
};

export default fr;
